export const ChambersConstant = {
    MAXIMUM_SPRITZES: 255,
};
